module.exports = __webpack_public_path__ + "img/mile3.0ce96379.jpg";